import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle2, ShieldCheck, Lock, Gift } from 'lucide-react';
export function Purchase() {
  const features = ['Recetas irresistibles', 'Estrategias de venta', 'Marketing emocional', 'Técnicas de presentación', 'Cómo calcular precios', 'Cómo conseguir clientes', 'Cómo empezar desde cero'];
  return <section id="comprar" className="py-20 bg-cream-100 bg-texture scroll-mt-10" data-id="element-151">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-152">
        <div className="text-center mb-12" data-id="element-153">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl font-bold text-brown-900 mb-4" data-id="element-154">
            Presentamos:
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl sm:text-5xl font-bold text-burgundy-600 font-serif mb-6" data-id="element-155">
            “Del Horno a Tu Primer Ingreso”
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-brown-800/80 max-w-2xl mx-auto" data-id="element-156">
            La guía práctica que te enseña cómo convertir budines caseros en un
            negocio rentable desde casa.
          </motion.p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-cream-200 max-w-4xl mx-auto flex flex-col md:flex-row" data-id="element-157">
          {/* Left side - Image & Features */}
          <div className="p-8 md:p-10 md:w-1/2 bg-cream-50 border-r border-cream-200" data-id="element-158">
            <img src="https://cdn.magicpatterns.com/uploads/oq5ymwAaDAhMNDNwzMmZYu/Untitled_design-removebg-preview.png" alt="Del Horno a Tu Primer Ingreso" className="w-full max-w-sm mx-auto drop-shadow-xl mb-8" data-id="element-159" />

            <h4 className="font-bold text-xl text-brown-900 mb-4" data-id="element-160">
              Dentro encontrarás:
            </h4>
            <ul className="space-y-3" data-id="element-161">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-162">
                  <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-163" />
                  <span className="text-brown-800 font-medium" data-id="element-164">{feature}</span>
                </li>)}
            </ul>

            <p className="mt-6 font-bold text-burgundy-600 italic" data-id="element-165">
              Aunque hoy no sepas por dónde empezar.
            </p>
          </div>

          {/* Right side - Pricing & Checkout */}
          <div className="p-8 md:p-10 md:w-1/2 flex flex-col justify-center items-center text-center" data-id="element-166">
            <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-bold mb-6" data-id="element-167">
              <span className="relative flex h-2 w-2" data-id="element-168">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-169"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-170"></span>
              </span>
              OFERTA DISPONIBLE HOY
            </div>

            <div className="mb-2" data-id="element-171">
              <span className="text-brown-800/50 text-xl font-medium line-through" data-id="element-172">
                Precio normal: $49.990
              </span>
            </div>

            <div className="mb-8 flex items-start justify-center" data-id="element-173">
              <span className="text-3xl font-bold text-brown-900 mt-2" data-id="element-174">$</span>
              <span className="text-6xl sm:text-7xl font-black text-brown-900 tracking-tight" data-id="element-175">
                19.990
              </span>
              <span className="text-lg font-bold text-brown-800/60 mt-auto mb-2 ml-1" data-id="element-176">
                ARS
              </span>
            </div>

            <div className="w-full space-y-4 mb-8" data-id="element-177">
              <div className="flex items-center justify-center gap-2 text-sm font-medium text-brown-800/80 bg-cream-100 py-2 rounded-lg" data-id="element-178">
                <Gift className="w-4 h-4 text-burgundy-600" data-id="element-179" />
                Incluye los 5 bonos de regalo
              </div>
            </div>

            <Button href="https://checkout.simplementehacelo.shop/cart/48432383557881:1" className="w-full py-5 text-xl shadow-xl" data-id="element-180">
              QUIERO EMPEZAR AHORA
            </Button>

            <div className="mt-6 flex flex-col items-center gap-3 text-sm text-brown-800/60" data-id="element-181">
              <div className="flex items-center gap-4" data-id="element-182">
                <div className="flex items-center gap-1.5" data-id="element-183">
                  <Lock className="w-4 h-4" data-id="element-184" /> Pago Seguro
                </div>
                <div className="flex items-center gap-1.5" data-id="element-185">
                  <ShieldCheck className="w-4 h-4" data-id="element-186" /> Garantía 7 días
                </div>
              </div>
              <p data-id="element-187">Acceso inmediato al material digital</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}